import { render, staticRenderFns } from "./imgSlide.vue?vue&type=template&id=2cb037ef&scoped=true"
import script from "./imgSlide.vue?vue&type=script&lang=js"
export * from "./imgSlide.vue?vue&type=script&lang=js"
import style0 from "./imgSlide.vue?vue&type=style&index=0&id=2cb037ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb037ef",
  null
  
)

export default component.exports